import { stringToNumber } from 'utils'

function evalMath(expr: string): number {
  try {
    expr = expr.replace(/\s+/g, '')

    if (!/^[0-9+\-*/().]+$/.test(expr)) {
      throw new Error('Expressão inválida')
    }

    const output: any[] = []
    const operators: any[] = []
    const precedence: any = { '+': 1, '-': 1, '*': 2, '/': 2 }

    const tokens = expr.match(/[0-9.]+|[()+\-*/]/g)

    tokens?.forEach((token) => {
      if (!isNaN(Number(token))) {
        output.push(Number(token))
      } else if (token in precedence) {
        while (
          operators.length &&
          precedence[operators[operators.length - 1]] >= precedence[token]
        ) {
          output.push(operators.pop())
        }
        operators.push(token)
      } else if (token === '(') {
        operators.push(token)
      } else if (token === ')') {
        while (operators.length && operators[operators.length - 1] !== '(') {
          output.push(operators.pop())
        }
        operators.pop()
      }
    })

    while (operators.length) {
      output.push(operators.pop())
    }

    const stack: number[] = []

    output.forEach((token) => {
      if (typeof token === 'number') {
        stack.push(token)
      } else {
        const b = stack.pop()!
        const a = stack.pop()!
        switch (token) {
          case '+':
            stack.push(a + b)
            break
          case '-':
            stack.push(a - b)
            break
          case '*':
            stack.push(a * b)
            break
          case '/':
            stack.push(a / b)
            break
        }
      }
    })

    return stack[0]
  } catch (err) {
    console.error('Erro ao avaliar expressão matemática:', err)
    return 0
  }
}

function interpret(expr: string): any {
  expr = expr.trim()

  if (/^-?\d+(\.\d+)?$/.test(expr)) {
    return Number(expr)
  }

  const match = expr.match(/^SE\((.*)\)$/)
  if (match) {
    const inside = match[1]

    const parts = []
    let current = ''
    let depth = 0

    for (const char of inside) {
      if (char === '(') depth++
      if (char === ')') depth--
      if (char === ':' && depth === 0) {
        parts.push(current)
        current = ''
      } else {
        current += char
      }
    }
    parts.push(current)

    const [cond, ifTrue, ifFalse] = parts

    const condMatch = cond.match(/^(.+)==(.+)$/)
    if (!condMatch) throw new Error('Condição inválida: ' + cond)

    const left: any = interpret(condMatch[1])
    const right: any = interpret(condMatch[2])

    return left === right ? interpret(ifTrue) : interpret(ifFalse)
  }

  if (/^[0-9\\.\-\\+\\*\\/\\(\\) ]+$/.test(expr)) {
    return evalMath(expr)
  }

  throw new Error('Expressão inválida: ' + expr)
}

/**
 * Evaluates a configuration field expression by substituting field values
 * and computing the result.
 */
export function interpretExpression(
  expression: string,
  fields: Record<string, any>
): number {
  const newFormKeys: any = {}

  Object.keys(fields).forEach((key) => {
    newFormKeys[`;C${key}`] = Number(
      stringToNumber(fields[key]?.content) || stringToNumber(fields[key])
    )
  })

  let exp = expression

  Object.keys(newFormKeys).forEach((key) => {
    exp = exp.replaceAll(key, newFormKeys[key])
  })

  exp = exp.replace(/=/g, '==')
  exp = exp.replace(/(\d),(\d)/g, '$1.$2')

  try {
    return interpret(exp)
  } catch (err) {
    console.error(err)
    return 0
  }
}
